module.exports = __webpack_public_path__ + "img/40.c4bca293.jpg";